"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _video = _interopRequireDefault(require("video.js"));
var _qs = _interopRequireDefault(require("qs"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _last = _interopRequireDefault(require("lodash/last"));
var _lodash = require("lodash");
var _DebugManager = _interopRequireDefault(require("../utils/DebugManager"));
var _utility = require("./utility");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// videoLibrary can be overriden with a custom JS video library, if desired
// this also makes testing/mocking easier:

var RampVideoPlayer = function RampVideoPlayer(videoId, config) {
  var videoLibrary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _video["default"];
  var dmInstance = _DebugManager["default"].dmInstance;
  var debug = dmInstance.debug.includes(_DebugManager["default"].debugLevel.M);
  var verbose = false;
  var url = window.location.href;
  var queryString = (0, _last["default"])(url.split('?'));
  var _pick = (0, _pick2["default"])(_qs["default"].parse(queryString), 'mAddr'),
    mAddr = _pick.mAddr;
  var player;
  if (debug) {
    dmInstance.logMessage([_DebugManager["default"].debugLevel.M], '[RampVideoPlayer] config: ', config);
    dmInstance.logMessage([_DebugManager["default"].debugLevel.M], '[RampVideoPlayer] using multicast address: ', mAddr || config.mAddr);
    dmInstance.logMessage([_DebugManager["default"].debugLevel.M], '[RampVideoPlayer] fallback url: ', config.fallbackUrls[0]);
    verbose = true;
  }
  window.videojs = _video["default"];
  dmInstance.log('[RampVideoPlayer] videojs version: ', _video["default"].VERSION);
  var playerPromise = new Promise(function (resolve) {
    var load = function load() {
      player = videoLibrary(videoId, _objectSpread(_objectSpread({}, config), {}, {
        plugins: {
          multicast: {
            overlay: false,
            verbose: verbose,
            params: {
              maddr: mAddr || config.mAddr,
              streamKey: true,
              allowFallback: true,
              fallbackUrl: (0, _utility.appendURLParams)(config.fallbackUrls[0].src, config.params)
            }
          }
        }
      }));
      (0, _utility.setupHooks)(player, config);
      var urls = config.urls;
      setSourceList(urls);
      resolve(player);
    };
    // eslint-disable-next-line no-new, no-underscore-dangle
    new window._Loader(load, [{
      field: 'ramp-ecdn-plugin-videojs',
      src: '//livetools.rampecdn.com/plugin/alpha/ramp-ecdn-plugin-videojs.js',
      kind: 'js',
      alternate: '//livetools.rampecdn.com/plugin/alpha/ramp-ecdn-plugin-videojs.js'
    }]);
  });
  function setSourceList(urls) {
    if (!Array.isArray(urls) || (0, _lodash.isEmpty)(urls)) {
      console.warn('[RampVideoPlayer] Invalid URLs supplied to the video player.');
      return false;
    }
    var urlList = (0, _utility.processUrls)(urls, config);
    player.src(urlList);
    dmInstance.logMessage([_DebugManager["default"].debugLevel.M], '[RampVideoPlayer] source urls: ', urls);
    return true;
  }
  return playerPromise;
};
var _default = exports["default"] = RampVideoPlayer;